module.exports = __webpack_public_path__ + "img/normal-big.500fde6f.svg";